/**
 * @description 品目管理相关接口
 */
import request from '@/utils/request'

const purchaseApi = process.env.VUE_APP_PURCHASE_API

// 获取品目分类目录
export function getMaterialClassifyTreeApi() {
  return request({
    url: purchaseApi + '/workbench/items/all-categories/detail',
    method: 'get'
  })
}

// 添加分类
export function addMaterialClassifyApi(data) {
  return request({
    url: purchaseApi + '/workbench/items/categories',
    method: 'post',
    data
  })
}

// 更新品目分组
export function updateMaterialClassifyApi(data) {
  const { categoryId } = data
  return request({
    url: purchaseApi + `/workbench/items/categories/${categoryId}`,
    method: 'put',
    data
  })
}

// 删除品目分组
export function removeMaterialClassifyApi(categoryId) {
  return request({
    url: purchaseApi + `/workbench/items/categories/${categoryId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 分页查询品目列表
export function getMaterialPageByClassifyApi(params) {
  return request({
    url: purchaseApi + '/workbench/items/page',
    method: 'get',
    params
  })
}

// 新增品目
export function addMaterialApi(data) {
  return request({
    url: purchaseApi + '/workbench/items',
    method: 'post',
    data
  })
}

// 更新品目
export function updateMaterialApi(data) {
  const { itemId } = data
  return request({
    url: purchaseApi + `/workbench/items/${itemId}`,
    method: 'put',
    data
  })
}

// 删除品目
export function removeMaterialApi(itemId) {
  return request({
    url: purchaseApi + `/workbench/items/${itemId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
